const PLATFORM_LABELS: Record<string, string> = {
  phone: "Call",
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  facebook: "Facebook",
  linkedin: "LinkedIn",
  youtube: "YouTube",
  tiktok: "TikTok",
  twitter: "X",
  x: "X",
  telegram: "Telegram",
  snapchat: "Snapchat",
  email: "Email",
  website: "Website",
  location: "Location",
  maps: "Location",
  payment: "Payment",
  custom: "Link",
};

export function platformLabel(key: string | null | undefined): string {
  if (!key) return "Link";
  const k = key.toLowerCase();
  if (PLATFORM_LABELS[k]) return PLATFORM_LABELS[k];
  return k
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(" ");
}
